import {useState,useEffect} from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { parseJwt } from "./utils/jwt/parseJwt";
import { useAuth } from "./contexts/AuthContext";
import axiosInstance from "./axiosInstance";
import axios from "axios";
import { TEMP_ROLE_DATA } from "./components/MenuData";
const isDev = process.env.REACT_APP_IS_DEV === 'true';

const ProtectedRoute: React.FC = () => {
  const [isVerified, setIsVerified] = useState<boolean | null>(null);
  const location = useLocation();
  const { refreshKey, refreshAction, isWorkerAction, setRolesAction} = useAuth();

  interface RefreshResponse {
    accessToken: string;
    refreshToken: string;
  }

  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");
    const payload = accessToken ? parseJwt(accessToken) : null;
    const now = Math.floor(Date.now() / 1000);

    if(isDev){
      validateRoles();
    }else{
      if (!payload || now > payload.exp) {
        getRefToken();
      }else{
        validateRoles();
        payload.workerYn === 'Y' ? isWorkerAction(true) : isWorkerAction(false);
      }
    }
    
  }, [refreshKey]);

  const authFailAction = () => {
    localStorage.clear();
    setIsVerified(false);
  }

  const validateRoles = () =>{
    getRoles().then((roles)=>{
      setRolesAction(roles);
      if(roles.length < 1){
        authFailAction();
      }else{
        const currentPath = location.pathname;
        const currentPerm = roles.find((r: any) => r.apiUrl === currentPath);
        if (currentPerm?.isRead === 'Y') {
          setIsVerified(true);
        } else {
          const redirectTarget = roles.find((r: any) => r.isRead === 'Y')?.apiUrl;
          if (redirectTarget) {
            window.location.replace(redirectTarget);
          } else {
            authFailAction();
          }
        }
      }
    });
  }

  const getRefToken = async () => {
    try {
      const refreshToken = localStorage.getItem("refreshToken");
      const { data }: { data: RefreshResponse } = await axios.post(
        "/api/v1/auth/refresh",
        null,
        { headers: { "X-REFRESH-TOKEN": refreshToken } }
      );    
      // 새 토큰 저장
      localStorage.setItem("accessToken", data.accessToken);
      localStorage.setItem("refreshToken", data.refreshToken);
      refreshAction();
    } catch (refreshError: any) {
      authFailAction();
    }
  }
  
  const getRoles = async () => {
    try{
      if(isDev){
        return TEMP_ROLE_DATA();
      }else{
        const res = await axiosInstance.get('/api/v1/auth/user/roles');
        const d = res.data as any;
        return d.data || [];
      }
    }catch(e){
      return [];
    }
  }

  if (isVerified === null) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          fontSize: "1.2rem",
        }}
      >
        🔐 인증 확인 중...
      </div>
    );
  }

  if (!isVerified) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  /*
  if (!accessToken && !refreshToken && location.pathname !== "/login") {
    return <Navigate to="/login" replace />;
  }
*/
  return <Outlet />;
};

export default ProtectedRoute;
